import _axios from 'axios';
import routes from '../routes';
import types from '../redux/types';

const axios = _axios.create({ baseURL: "https://base.coinstable.io/",headers:{
  Authorization: "Bearer "+localStorage.getItem("firoz_token")
} })
export const setupAxiosInterceptors = (dispatch) => {
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response.status === 401) {
        dispatch({ type: types.LOGOUT_SUCCESS });
        if (window.location.pathname !== routes.Auth.Login.path) {
          window.location.href = routes.Auth.Login.path;
        }
      } else if (error.response.status === 500) {
        console.error("Server error - please try again later.");
      }
      return Promise.reject(error);
    }
  );
};
export default {
  auth: {
    getAdmin: () => axios.get('/api/admin/current'),
    login: data => axios.post('/api/admin/login', data),
    logout: () => axios.post('/api/admin/logout'),
    forgotPassword: data => axios.put('/api/admin/password/change', data),
    getUser: () => axios.get('/api/user'),
    getKYCAuthToken: () => axios.get('/api/admin/user/kyc/auth'),
  },
  users: {
    getUsersList: params => axios.get('/api/admin/users', { params }),
    blockUser: ({ id, data }) => axios.put(`/api/admin/user/${id}/blocked`, data),
    deleteUser: id => axios.delete(`/api/admin/user/${id}`),
    verificationUser: id =>
      axios.put(`/api/admin/user/${id}/kyc_verification/toggle_check`),
  },
  ledger: {
    getContractUrl: () => axios.get(`/api/admin/rpc_url`),
  },
  profile: {
    putDisable2FA: id => axios.put(`/api/admin/user/${id}/2fa/disable`),
    getUserAccount: id => axios.get(`/api/admin/user/${id}/account`),
    getUserBalances: id => axios.get(`/api/admin/user/${id}/balances`),
    getUserOrders: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/orders`, { params }),
    getUserInstantExchangeOrders: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/exchanges`, { params }),
    getUserTransactions: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/transactions`, { params }),
    getUserFiatPayment: ({ params }) =>
      axios.get('/api/admin/payment/all', { params }),
    getTradeHistory: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/orders_transactions/margin`, { params }),
    getRepayments: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/repays`, { params }),
    getTransfers: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/user_margin_balance_history`, { params }),
    getUserMarginBalance: id => axios.get(`/api/admin/user/${id}/margin_balances`),
    getUserKycVerifications: id =>
      axios.get(`/api/admin/user/${id}/kyc_verification`),
    updateKycVerifications: ({ id, data }) =>
      axios.post(`/api/admin/user/${id}/kyc_verifications`, data),
    putKycDocumentStatus: ({ id, data }) =>
    axios.put(`/api/admin/user/${id}/kyc_document_status`, data),
    putUserStatus: ({ id, data }) =>
      axios.put(`/api/admin/user/${id}/account/status`, data),
    getUserHotTransactions: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/temp_hot_transactions`, { params }),
    updateUserBalance: ({ id, data }) => axios.put(`/api/admin/user/balance`, data),
    getUserLoginHistory: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/login_history`, { params }),
    putClearUserPhoneNumber: ({ id }) =>
      axios.put(`/api/admin/user/${id}/phone_turn_off`),
    // putSetUserPhoneNumber: ({ id, data }) =>
    //   axios.put(`/api/admin/user/${id}/phone_set_confirm`, data),
    getUserSecurityOptions: ({ id }) =>
      axios.get(`/api/admin/user/${id}/security/options`),
    putUserSecurityOptions: ({ id, data }) =>
      axios.put(`/api/admin/user/${id}/security/options`, data),
    putResetWithdrawalUserSecretPhrase: ({ id }) =>
      axios.put(`/api/admin/user/${id}/security/secret_turn_off`),
    getUserUniqueDevices: ({ id }) =>
      axios.get(`/api/admin/user/${id}/security/devices`),
    deleteUserUniqueDevice: ({ id, params }) =>
      axios.delete(`/api/admin/user/${id}/security/device/delete`, { params }),
    getUserWithdrawalWhiteAddresses: ({ id }) =>
      axios.get(`/api/admin/user/${id}/security/white_addresses`),
  },
  orders: { 
    getOrders: params => axios.get(`/api/admin/orders`, { params }),
  },
  videos: {
    getVideos: () => axios.get('/api/media'),
    updateVideo: data => axios.put('/api/admin/media', data),
    createVideo: data => axios.post('/api/admin/media', data),
    deleteVideo: data => axios.delete('/api/admin/media', { data }),
  },
  vacancies: {
    getVacancies: params => axios.get('/api/vacancy', { params }),
    getSingleVacancy: id => axios.get(`/api/vacancy/${id}`),
    updateVacancies: data => axios.put('/api/admin/vacancy', data),
    createVacancies: data => axios.post('/api/admin/vacancy', data),
    deleteVacancies: data => axios.delete('/api/admin/vacancy', { data }),
  },
  posts: {
    getPosts: params => axios.get('/api/blog/posts', { params }),
    getSinglePost: ({ postId, lang }) =>
      axios.get(`/api/blog/post/${postId}?lang=${lang}`),
    createPost: data => axios.post('/api/admin/blog/post', data),
    updatePost: data => axios.put('/api/admin/blog/post', data),
    deletePost: ({ id }) => axios.delete(`/api/admin/blog/post/${id}`),
    createPostContent: data => axios.post('/api/admin/blog/post/content', data),
    updatePostContent: data => axios.put(`/api/admin/blog/post/content`, data),
    deletePostContent: ({ postId, lang }) =>
      axios.delete(`/api/admin/blog/post/content/${postId}/${lang}`),

    getCategoryList: () => axios.get('/api/blog/categories'),
    getSingleCategory: ({ categoryId, lang }) =>
      axios.get(
        `/api/admin/blog/category/${categoryId}${lang ? `?lang=${lang}` : ''}`,
      ),
    createCategory: data => axios.post('/api/admin/blog/category', data),
    updateCategory: data => axios.put('/api/admin/blog/category', data),
    deleteCategory: ({ id }) => axios.delete(`/api/admin/blog/category/${id}`),
    createCategoryContent: data =>
      axios.post('/api/admin/blog/category/content', data),
    updateCategoryContent: data =>
      axios.put(`/api/admin/blog/category/content`, data),
    deleteCategoryContent: ({ categoryId, lang }) =>
      axios.delete(`/api/admin/blog/category/content/${categoryId}/${lang}`),
  },
  traderInfo: {
    getTraderInfo: () => axios.get('/api/admin/info/main'),
    updateTraderInfo: data => axios.put('/api/admin/info/main', data),
  },
  market: {
    pairs: {
      getPairs: () => axios.get('/api/admin/pairs'),
      postPair: data => axios.post('/api/admin/asset_pair', data),
      updatePairs: data => axios.put('/api/admin/pairs', data),
      updateTopPairs: data => axios.put('/api/admin/top_pairs', data),
    },
    tokens: {
      getTokens: () => axios.get('/api/admin/assets'),
      postTokens: data => axios.post('/api/admin/token', data),
    },
    limitation: {
      getLimitations: () => axios.get('/api/admin/limitation'),
      updateLimitations: data => axios.put('/api/admin/limitation', data),
    },
    fees: {
      getFees: () => axios.get('/api/admin/fees?level_id=1'), // TEMP level_id
      updateFees: data => axios.put('/api/admin/fees', data),
    },
    currencies: {
      getCurrencies: () => axios.get('/api/admin/assets'),
      updateCurrencies: data => axios.put('/api/admin/asset', data),
    },
    robot: {
      getRobot: params =>
        axios.get('/api/admin/market_maker/spot/settings', { params }),
      putRobot: data => axios.put('/api/admin/market_maker/spot/settings', data),
      putToggleEnabled: () =>
        axios.put('/api/admin/market_maker/spot/toggle_enabled'),
      putToggleEnabledVersionBots: data =>
        axios.put('/api/admin/market_maker/spot/enable_bot', data),
      getMarketVolumeRates: () =>
        axios.get('/api/admin/market_maker/spot/market_volume_rates'),
      updateMarketVolumeRate: data =>
        axios.put('/api/admin/market_maker/spot/quantity_rate', data),
      updateMarketVolumeLimits: data =>
        axios.put('/api/admin/market_maker/spot/volute_limits', data),
    },
  },
  fiatTransfer: {
    getWithdraw: params => axios.get('/api/admin/payment/withdraw', { params }),
    getDeposit: params => axios.get('/api/admin/payment/deposit', { params }),
    getPending: params =>
      axios.get('/api/admin/payment/withdraw/pending', { params }),
    postWithdrawComplete: body =>
      axios.post('/api/admin/payment/payeer/withdraw/complete', body),
    postWithdrawCancel: body =>
      axios.post('/api/admin/payment/payeer/withdraw/cancel', body),
    // putPending: data => axios.put('/api/admin/transactions/withdrawal', data),
    // getWithdrawals: params =>
    //   axios.get('/api/admin/transactions/withdrawals', { params }),
  },
  transfer: {
    getDeposit: params => axios.get('/api/admin/transactions/deposits', { params }),
    getPending: params =>
      axios.get('/api/admin/transactions/withdrawals/pending', { params }),
    putPending: data => axios.put('/api/admin/transactions/withdrawal', data),
    getWithdrawals: params =>
      axios.get('/api/admin/transactions/withdrawals', { params }),
  },
  wallets: {
    getWallets: () => axios.get('/api/admin/hot_wallets_data'),
    updateTransfer: data => axios.put('/api/admin/hot_wallets_settings', data),
    getAddres: params => axios.get('/api/admin/get_hot_wallet_address', { params }),
    transfetToCold: data => axios.post('/api/admin/withdraw_to_cold_wallet', data),
    getProfit: () => axios.get('/api/admin/profit'),
    getTransactions: params =>
      axios.get('/api/admin/hot_cold_transactions', { params }),
    getBnixFee: () => axios.get('/api/admin/bnix_fee'),
    updateBnixFee: data => axios.put('/api/admin/bnix_fee', data),
    getGasFeeSettings: () => axios.get('/api/admin/gas_settings'),
    updateGasFeeSettings: data => axios.put('/api/admin/gas_settings', data),
    getCurrentGasPrice: () => axios.get('/api/admin/gas_price'),
    getReplenishedHistory: ({ params }) =>
      axios.get(`/api/admin/user/balance_transactions`, { params }),
  },
  referrals: {
    getReferrals: params => axios.get('/api/admin/invitations', { params }),
    getReferralsExcel: params =>
      axios.get('/api/admin/referral/export/excel', { params }),
    getReferralsXml: params =>
      axios.get('/api/admin/referral/export/xml', { params }),
    getReferralsStatistics: params =>
      axios.get('/api/admin/referral_statistics', { params }),
    getUserListOfReferrals: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/referrals/list`, { params }),
    getUserfReferralsBonuses: ({ id, params }) =>
      axios.get(`/api/admin/user/${id}/referrals/bonuses`, { params }),
  },
  projects:{
    getProjects: params => axios.get('/api/admin/projects', { params }),
    getShowProject: id => axios.get(`/api/admin/projects/${id}`),
    // deleteProject: id => axios.delete(`/api/admin/projects/delete/${id}`)s
  }, 
  admins: {
    getAdmins: params => axios.get('/api/admin/admins', { params }),
    getPermissions: () => axios.get('/api/admin/permissions'),
    deleteAdmin: id => axios.delete(`/api/admin/admin/${id}`),
    postAdmin: data => axios.post('/api/admin/admins', data),
    putAdmin: (id, data, permissions) =>
      axios.put(`/api/admin/admin/${id}`, { data, permissions }),
  },
  setting: {
    changePass: data => axios.put('/api/admin/password/change', data),
    getSecretKey: () => axios.get('/api/admin/2fa/generate_secret_key'),
    enableTwoFA: data => axios.post('/api/admin/2fa/enable', data),
    disableTwoFA: data => axios.post('/api/admin/2fa/disable', data),
    getAccount: () => axios.get('/api/admin/bank_settings/index'),
    putAccount: data => axios.put('/api/admin/bank_settings/update', data),
    getBotUrl: () => axios.get('/api/admin/telegram/url/get'),
    updateAdminChatId: data => axios.post('/api/admin/telegram/chatid/update', data),
  },
  reset_2FA: {
    getUsersReset2FA: body => axios.get(`/api/admin/2fa/reset`, body),
    putResetRequest2FA: data => axios.put(`/api/admin/2fa/reset`, data),
    postRejectRequest2FA: data => axios.post(`/api/admin/2fa/reject`, data),
  },
  cashback: {
    getCashbacks: () => axios.get(`/api/admin/cashback`),
    createCashback: data => axios.post(`/api/admin/cashback/new`, data),
    editCashback: data => axios.put(`/api/admin/cashback/edit`, data),
    deleteCashback: params => axios.delete(`/api/admin/cashback/delete`, params),
    getUsersCashback: params => axios.get('/api/admin/cashback_users', { params }),
  },
  feesAndLimits: {
    getFeesAndLimits: () => axios.get(`/api/admin/pairs/fees`),
    editFeesAndLimits: data => axios.put(`/api/admin/pairs/fees`, data),
  },
  tradeVolumeSettings: {
    getTradeVolumeSettings: () => axios.get(`/api/admin/volume_settings`),
    editTradeVolumeSettings: data => axios.put(`/api/admin/volume_settings`, data),
  },
  trades: {
    getTrades: params => axios.get('/api/admin/trades', { params }),
  },
  chat: {
    getChatModerators: params => axios.get('/api/admin/chat/users', { params }),
    postChatModerator: data => axios.post('/api/admin/chat/chat_moderator', data),
    putChatModeratorRole: data => axios.put('/api/admin/chat/user_role', data),
  },
  vote: {
    getVotingProjects: params =>
      axios.get(`/api/admin/votings/${params.type}`, {
        params: {
          lang: params.lang,
          current_page: params.current_page,
          per_page: params.per_page,
        },
      }),
    getSingleVoteProject: ({ voteId, lang }) =>
      axios.get(`/api/voting/${voteId}?lang=${lang}`),
    createVoteProject: data => axios.post('/api/admin/voting', data),
    updateVoteProject: data => axios.put('/api/admin/voting', data),
    deleteVoteProject: ({ id }) => axios.delete(`/api/admin/voting/${id}`),
    createVoteProjectContent: data => axios.post('/api/admin/voting/content', data),
    updateVoteProjectContent: data => axios.put('/api/admin/voting/content', data),
    deleteVoteProjectContent: ({ voteId, lang }) =>
      axios.delete(`/api/admin/voting/content/${voteId}/${lang}`),
    putVoteProjectPublished: data =>
      axios.put('/api/admin/voting/set_published', data),
    getProjectBalance: () => axios.get('/api/admin/votings/balances'),
    updateProjectBalance: data => axios.put('/api/admin/voting/balance', data),
  },
};
